import { registerEnumType } from 'type-graphql'

/** The secret families a tenant stores encrypted. The value is the kind name. */
export enum SecretKindEnum {
  Quickbooks = 'Quickbooks',
  PayrollApi = 'PayrollApi',
  Sftp = 'Sftp',
  Ach = 'Ach',
  PositivePay = 'PositivePay',
  CheckSignature = 'CheckSignature',
}

registerEnumType(SecretKindEnum, {
  name: 'SecretKindEnum',
  description: 'The secret kinds a tenant stores encrypted',
})
